export const BASE_URL = `https://sohoanongnghiep.com`;
export const API_KEY = `zqehe5wmr4c69yfxky8qujm6w5v91fbg02yenivy6y90xn65`